import React, { useEffect, useState } from 'react';
import { Container, Stack } from '@mui/material';

import { Page } from '../../../../components';
import HeaderBreadcrumbs from '../../../../components/header-breadcrumbs';
import { SystemUserForm } from '../../../../components/forms/system-user-form';
import { useNavigate, useParams } from 'react-router-dom';
import { SystemUserTypes } from '../../../../types';
import { SystemUserService } from '../../../../services/system-user.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { toast } from 'react-toastify';
import { When } from 'react-if';
import { hasIntakeAddon, returnRoleFromPermissions } from '../../../../helpers/permissionCheck';
import { TeamService } from '../../../../services/team.service';
import { GroupService } from '../../../../services/groups.service';

export const EditSystemUserScreen: React.FC = () => {
    const { loading } = useSelector((state: RootState) => state.systemUser);
    const [systemUser, setSystemUser] = useState<SystemUserTypes.Model | null>();

    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Load teams and groups for the form dropdowns
        TeamService.fetchAll();
        GroupService.fetchAll();
        
        SystemUserService.getById(id!, (isValid, msg, result) => {

            if (!isValid) {
                toast(
                    msg, 
                    {
                        autoClose: 1500,
                        type: 'error',
                    }
                );

                navigate('/system-users');
                return;
            }

            // Attach teamIds and groupIds from the API response
            if (result) {
                setSystemUser({
                    ...result,
                    teamIds: result.teamIds || [],
                    groupIds: result.groupIds || [],
                });
            }
          
        });
    }, [id]);

    return (
        <Page title="POM - Edit System Users">
            <Container maxWidth={false}>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <HeaderBreadcrumbs
                        heading="Edit System Users"
                        links={[
                            {
                                name: 'List',
                                href: '/system-users'
                            },
                            {
                                name: 'Edit',
                                href: `/system-users/${id}/edit`
                            },
                        ]}
                        activeLast={false}
                    />
                </Stack>
                <When condition={systemUser && !loading.getById}>
                    <SystemUserForm 
                        defaultValues={{
                            id: systemUser?.id,
                            alertSettings: systemUser?.alertSettings!,
                            email: systemUser?.email!,
                            fullname: systemUser?.fullname!,
                            homeLocation: systemUser?.homeLocation!,
                            phone: systemUser?.phone?.startsWith('+1') ? systemUser?.phone!.replace('+1', '') : systemUser?.phone!,
                            userType: returnRoleFromPermissions(systemUser?.permissionFlags || {}),
                            grantIntakeRiskAssessment: hasIntakeAddon(systemUser?.permissionFlags || {}),
                            teamIds: systemUser?.teamIds || [],
                            groupIds: systemUser?.groupIds || [],
                        }}
                        fromEdit
                    />
                </When>
                
            </Container>
        </Page>
    )
}